/**
 * 是否是undefined
 * @param value
 * @return {boolean}
 */
export function isUndefined(value) {
  return typeof value === "undefined";
}
